import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6e3b0264"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "sale"
};
const _hoisted_3 = {
  key: 0,
  class: "price"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box1"
}, [/*#__PURE__*/_createElementVNode("div", null, "Free")], -1));

const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  key: 1,
  class: "price"
};
const _hoisted_7 = {
  class: "box1"
};
const _hoisted_8 = {
  class: "priceBtn width150 ma br15"
};
const _hoisted_9 = {
  class: "priceInfo"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));

const _hoisted_11 = {
  class: "price-discount-text"
};
const _hoisted_12 = {
  class: "buy"
};
const _hoisted_13 = {
  key: 2,
  class: "price"
};
const _hoisted_14 = {
  class: "box1"
};
const _hoisted_15 = {
  class: "priceBtn width150 ma br15"
};
const _hoisted_16 = {
  class: "priceInfo"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));

const _hoisted_18 = {
  class: "price-discount-text"
};
const _hoisted_19 = {
  class: "buy"
};
const _hoisted_20 = {
  key: 3,
  class: "price minH122"
};
const _hoisted_21 = {
  class: "box1"
};
const _hoisted_22 = {
  class: "contact"
};
const _hoisted_23 = {
  class: "chat"
};
const _hoisted_24 = {
  class: "buy"
};
const _hoisted_25 = {
  class: "blue-intro"
};
const _hoisted_26 = {
  class: "blue-intro-title"
};
const _hoisted_27 = {
  class: "blue-intro-exp"
};
const _hoisted_28 = {
  class: "blue-intro-link"
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://huashunxinan.net/product-foeye"
}, "https://huashunxinan.net/product-foeye", -1));

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiaoshourenyuan"
}, null, -1));

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icona-dianhua2"
}, null, -1));

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "underline"
}, " 400-650-2031 ", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_edition = _resolveComponent("edition");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("Choose your edition")), 1), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editionList, (item, key) => {
    return _openBlock(), _createBlock(_component_edition, {
      key: key,
      keys: key,
      title: _ctx.$t(item.title),
      desc: _ctx.$t(item.desc),
      feature: item.feature,
      class: _normalizeClass({
        [item['title-class']]: true
      }),
      downData: _ctx.downList[key],
      onChange: _ctx.change,
      ref_for: true,
      ref: `edition${key}`
    }, {
      price: _withCtx(() => [key == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true), key == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
        class: "priceBorder pointer",
        style: _normalizeStyle({
          left: `${_ctx.vulScanCurrBtn * 0.5 * 100}%`
        })
      }, null, 4), _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = $event => _ctx.changeVulScanCurrBtn(0)),
        class: _normalizeClass({
          currBtn: _ctx.vulScanCurrBtn == 0,
          pointer: true
        })
      }, _toDisplayString(_ctx.$t("Month")), 3), _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = $event => _ctx.changeVulScanCurrBtn(1)),
        class: _normalizeClass({
          currBtn: _ctx.vulScanCurrBtn == 1,
          pointer: true
        })
      }, _toDisplayString(_ctx.$t("Year")), 3)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, [_withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.formatPrice(_ctx.vulScanLicenseCategory?.month_original_amount || 0)), 513), [[_vShow, _ctx.vulScanCurrBtn == 0 && _ctx.vulScanLicenseCategory?.month_discount_amount && _ctx.vulScanLicenseCategory?.month_original_amount]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.formatPrice(_ctx.vulScanLicenseCategory?.year_original_amount || 0)), 513), [[_vShow, _ctx.vulScanCurrBtn == 1 && _ctx.vulScanLicenseCategory?.year_discount_amount && _ctx.vulScanLicenseCategory?.year_original_amount]])]), _createElementVNode("span", null, _toDisplayString(_ctx.currency), 1), _createElementVNode("span", null, _toDisplayString(_ctx.formatPrice(_ctx.vulScanPrice)), 1), _hoisted_10, _createElementVNode("span", _hoisted_11, "/ " + _toDisplayString(_ctx.$t("computer")), 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", {
        class: "pointer",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.Buy(_ctx.vulScanLicenseCategory.id))
      }, _toDisplayString(_ctx.$t("Subscribe")), 1)])])) : _createCommentVNode("", true), key == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", {
        class: "priceBorder pointer",
        style: _normalizeStyle({
          left: `${_ctx.currBtn * 0.5 * 100}%`
        })
      }, null, 4), _createElementVNode("span", {
        onClick: _cache[3] || (_cache[3] = $event => _ctx.changeCurrBtn(0)),
        class: _normalizeClass({
          currBtn: _ctx.currBtn == 0,
          pointer: true
        })
      }, _toDisplayString(_ctx.$t("Month")), 3), _createElementVNode("span", {
        onClick: _cache[4] || (_cache[4] = $event => _ctx.changeCurrBtn(1)),
        class: _normalizeClass({
          currBtn: _ctx.currBtn == 1,
          pointer: true
        })
      }, _toDisplayString(_ctx.$t("Year")), 3)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, [_createElementVNode("span", null, [_withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.formatPrice(_ctx.licenseCategory0?.month_original_amount || 0)), 513), [[_vShow, _ctx.currBtn == 0 && _ctx.licenseCategory0?.month_discount_amount && _ctx.licenseCategory0?.month_original_amount]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.formatPrice(_ctx.licenseCategory0?.year_original_amount || 0)), 513), [[_vShow, _ctx.currBtn == 1 && _ctx.licenseCategory0?.year_discount_amount && _ctx.licenseCategory0?.year_original_amount]])])]), _createElementVNode("span", null, _toDisplayString(_ctx.currency), 1), _createElementVNode("span", null, _toDisplayString(_ctx.formatPrice(_ctx.price)), 1), _hoisted_17, _createElementVNode("span", _hoisted_18, "/ " + _toDisplayString(_ctx.$t("computer")), 1)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", {
        class: _normalizeClass(["pointer", {
          'had-trial': true
        }]),
        onClick: _cache[5] || (_cache[5] = $event => _ctx.Buy(_ctx.licenseCategory0.id))
      }, _toDisplayString(_ctx.$t("Subscribe")), 1)])])) : _createCommentVNode("", true), key == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("Enterprise exclusive services")), 1)])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("span", {
        class: "pointer enterprise-btn",
        onClick: _cache[6] || (_cache[6] = $event => _ctx.chat(_ctx.licenseCategory1.id))
      }, _toDisplayString(_ctx.$t("Contact sales")), 1)])])) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["keys", "title", "desc", "feature", "class", "downData", "onChange"]);
  }), 128))]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, "Goby" + _toDisplayString(_ctx.$t("Blue Team Edition Introduce")), 1), _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("The Goby Blue Team version adopts a B/S architecture, suitable for business scenarios of normalized asset and risk management in enterprises. Its core capabilities include large-scale supply chain asset detection and risk discovery. Its main functions include asset fingerprint recognition, risk asset identification, asset violation monitoring, asset change monitoring, component level PoC vulnerability scanning, vulnerability disposal management, multi-user permission configuration, and other modules, Provide continuous asset risk monitoring and emergency response capabilities for enterprises.")), 1), _createElementVNode("div", _hoisted_28, [_createTextVNode(_toDisplayString(_ctx.$t("Official Website")) + "： ", 1), _hoisted_29]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
    class: "blue-intro-btn",
    onClick: _cache[7] || (_cache[7] = $event => _ctx.chat(17)),
    size: "large",
    type: "primary"
  }, {
    default: _withCtx(() => [_hoisted_30, _createTextVNode(" " + _toDisplayString(_ctx.$t("Contact sales")), 1)]),
    _: 1
  }), _createVNode(_component_el_button, {
    size: "large",
    class: "blue-intro-btn gray-btn",
    type: "info",
    style: {
      "margin-left": "45px"
    }
  }, {
    default: _withCtx(() => [_hoisted_31, _hoisted_32]),
    _: 1
  })])])], 64);
}